import { AdminDropdownValuesData } from '@models/interfaces';

export const DROPDOWN_VALUES_DEFAULT_VALUE: AdminDropdownValuesData = {
  id: '',
  value: '',
};
